<portal-sub-nav [force]="force" route="enterprise-phone-book">
  <portal-menu-context [heading]="'menu.phonebook' | portalTranslate"></portal-menu-context>

  <!-- Phone Book -->
  <portal-sub-nav-item route="enterprise-phone-book-contacts">
    <ng-template portalTransclude>
      <span>{{ 'menu.contact' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Speed Dials -->
  <portal-sub-nav-item route="enterprise-speed-dials">
    <ng-template portalTransclude>
      <span>{{ 'menu.speedDials' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Export Import -->
  <portal-sub-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.IMPORT_PHONEBOOK],
    }"
    route="enterprise-phone-book-export-import"
  >
    <ng-template portalTransclude>
      <span>{{ 'menu.phonebook.export-import' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>
</portal-sub-nav>
